import React from 'react';
import ConsultationForm from '../components/ConsultationForm';

const ConsultationPage: React.FC = () => {
  return (
    <div>
      {/* Page Header */}
      <div className="bg-snudefryd-beige py-12">
        <div className="container-custom">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Konsultation</h1>
          <p className="text-lg text-gray-700 max-w-3xl">
            Book en personlig konsultation og få professionel rådgivning om din hunds ernæring.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Left Column - Information */}
          <div>
            <h2 className="text-2xl font-bold mb-6 text-snudefryd-blue">Hvorfor vælge en konsultation?</h2>
            
            <div className="space-y-6">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold mb-3 flex items-center">
                  <span className="w-8 h-8 bg-snudefryd-light-purple rounded-full flex items-center justify-center mr-3 text-snudefryd-blue font-bold">1</span>
                  Personlig ernæringsplan
                </h3>
                <p className="text-gray-700">
                  Få en skræddersyet ernæringsplan baseret på din hunds race, alder, vægt, aktivitetsniveau og eventuelle sundhedsproblemer.
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold mb-3 flex items-center">
                  <span className="w-8 h-8 bg-snudefryd-light-purple rounded-full flex items-center justify-center mr-3 text-snudefryd-blue font-bold">2</span>
                  Rådgivning
                </h3>
                <p className="text-gray-700">
                  Få svar på  dine spørgsmål om hundeernæring. 
                </p>
              </div>
              
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-semibold mb-3 flex items-center">
                  <span className="w-8 h-8 bg-snudefryd-light-purple rounded-full flex items-center justify-center mr-3 text-snudefryd-blue font-bold">3</span>
                  Løsning af ernæringsmæssige problemer
                </h3>
                <p className="text-gray-700">
                  Har din hund allergier, fordøjelsesproblemer eller andre udfordringer? Vi hjælper med at finde den rette kost til at afhjælpe disse problemer.
                </p>
              </div>
              
              {/* <div className="bg-white p-6 rounded-lg shadow-md"> 
                <h3 className="text-xl font-semibold mb-3 flex items-center">
                  <span className="w-8 h-8 bg-snudefryd-light-purple rounded-full flex items-center justify-center mr-3 text-snudefryd-blue font-bold">4</span>
                  Opfølgning og støtte
                </h3>
                <p className="text-gray-700">
                  Efter konsultationen får du løbende støtte og mulighed for opfølgende spørgsmål for at sikre, at din hund trives med den nye ernæringsplan.
                </p>
              </div>*/}
            </div>
          </div>
          
          {/* Right Column - Booking Form */}
          <div>
            <h2 className="text-2xl font-bold mb-6 text-snudefryd-blue">Book en konsultation</h2>
            <div className="bg-white p-6 rounded-lg shadow-md">
              <ConsultationForm />
            </div>
          </div>
        </div>
      </div>


      {/* Testimonials Section 
      <div className="bg-gray-50 py-12">
        <div className="container-custom">
          <h2 className="text-2xl font-bold mb-8 text-center">Hvad vores kunder siger</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Testimonial 1 
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-snudefryd-pink rounded-full flex items-center justify-center text-white font-bold">
                  MH
                </div>
                <div className="ml-4">
                  <h4 className="font-bold">Mette Hansen</h4>
                  <p className="text-sm text-gray-500">Ejer af Labrador</p>
                </div>
              </div>
              <p className="text-gray-700">
                "Min labrador havde problemer med overvægt og allergier. Efter konsultationen hos Snudefryd og en ny ernæringsplan, har han tabt sig og har meget færre allergiske reaktioner. Fantastisk service!"
              </p>
            </div>
            
            {/* Testimonial 2 
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-snudefryd-blue rounded-full flex items-center justify-center text-white font-bold">
                  JP
                </div>
                <div className="ml-4">
                  <h4 className="font-bold">Jens Petersen</h4>
                  <p className="text-sm text-gray-500">Ejer af Schæfer</p>
                </div>
              </div>
              <p className="text-gray-700">
                "Min schæfer havde fordøjelsesproblemer, men efter at have fulgt den skræddersyede ernæringsplan fra Snudefryd, er hans mave blevet meget bedre. Jeg er meget taknemmelig for den professionelle rådgivning."
              </p>
            </div>
            
            {/* Testimonial 3 
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-snudefryd-purple rounded-full flex items-center justify-center text-white font-bold">
                  LN
                </div>
                <div className="ml-4">
                  <h4 className="font-bold">Lise Nielsen</h4>
                  <p className="text-sm text-gray-500">Ejer af Chihuahua</p>
                </div>
              </div>
              <p className="text-gray-700">
                "Min lille chihuahua var meget kræsen med mad, men efter konsultationen hos Snudefryd fik jeg gode råd til, hvordan jeg kunne gøre maden mere appetitlig for ham. Nu spiser han med glæde og har fået mere energi."
              </p>
            </div>
          </div>
        </div>
      </div>*/}
    </div>
  );
};

export default ConsultationPage; 